const setTypeText = makeSetType('text');
const setTypeEmail = makeSetType('email');

/** @param {HTMLInputElement} element */
function EmailCapsFilter(element) {
	element.addEventListener('focus', setTypeText);
	element.addEventListener('blur', setTypeEmail);
	element.addEventListener('input', onInput);
	element.addEventListener('change', onInput);
}

/**
 * @param {Element} element
 * @param {string} type
 */
function setType(element, type) {
	element.type = type;
}

/** @param {string} type */
function makeSetType(type) {
	return ({ target }) => setType.call(target, type);
}

/** @param {HTMLInputElement} target */
function onInput({ target }) {
	// Remember cursor position
	const { selectionStart: cursorStart } = target;

	target.value = target.value.toLowerCase();

	// Set cursor position
	target.setSelectionRange(cursorStart, cursorStart);
}

function initEmailCapsFilter() {
	document.querySelectorAll('input[type="email"]').forEach(EmailCapsFilter);
}

document.addEventListener('DOMContentLoaded', initEmailCapsFilter);

export { EmailCapsFilter };
